<article class="msg-popup-group">

  <div class="msg-box">

    <div class="tit-box">서버에서 알림이 도착하였습니다.</div>

    <div class="txt-box"
         *ngIf="pushInfo?.title"
         [innerHTML]="pushInfo.title | resize | keepHtml">
    </div>

    <div class="txt-box"
         *ngIf="pushInfo?.body"
         [innerHTML]="pushInfo.body | resize | keepHtml">
    </div>

  </div>

  <div class="msg-menu-box">

    <a class="menu-btn type-2"
       *ngIf="pushInfo?.page"
       (click)="onGotoDetail($event)">자세히 보기</a>
    <a class="menu-btn type-3"
       (click)="onClickClose($event)">닫기</a>

  </div>
</article>
